import * as Sentry from '@sentry/browser'
import * as log from 'src/utils/log'
import { Notify } from 'quasar'
import { errors } from 'src/config'
import { get } from 'lodash'
import i18n from 'src/i18n/i18n'

function createErrorFromResponse (response, toastOptions = {}) {
  Notify.create(Object.assign(toastOptions, { message: getErrorFromResponse(response), type: 'negative' }))

  log.debugError(response)
  const errorCode = getErrorCodeFromResponse(response)

  if (errors.ignore.includes(errorCode)) {
    log.debug('Not reporting', errorCode)
    return
  }

  Sentry.configureScope(scope => {
    scope.setFingerprint(['api-error', errorCode])
    scope.setTag('error_code', errorCode)
  })

  Sentry.captureException(response)
}

function getErrorFromResponse (error) {
  let errorCode = getErrorCodeFromResponse(error)

  if (errorCode === 'VALIDATION') {
    // Return the first validation error
    return error.response.data.errors[Object.keys(error.response.data.errors)[0]][0]
  }

  return i18n.t(errorCode)
}

function getErrorCodeFromResponse (error) {
  return get(error, 'response.data.error_code', 'UNKNOWN_ERROR')
}

export { getErrorCodeFromResponse, getErrorFromResponse, createErrorFromResponse }
